import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { GeneralLedgerService } from '../../services/general-ledger.service';

@Component({
	selector: 'app-expense-by-department',
	templateUrl: './expense-by-department.component.html',
	styleUrls: ['./expense-by-department.component.scss']
})
export class ExpenseByDepartmentComponent implements OnInit {
	periods: any = [];
	formGroup: UntypedFormGroup;
	loading = false;
	report: any = null;
	title = '';
	from_period_options: any = [];
	to_period_options: any = [];
	tags: any[] = [];
	color: any = '';

	constructor(
		private location: Location,
		private generalLedgerService: GeneralLedgerService,
		private globalSearchService: GlobalSearchService,
		private fb: UntypedFormBuilder
	) {}

	ngOnInit(): void {
		this.color = this.globalSearchService.getColor();
		this.generalLedgerService.getPeriods().subscribe((results: any) => {
			this.periods = results.periods || [];
			this.from_period_options = this.periods;
			this.to_period_options = this.periods;
			this.formGroup = this.fb.group({
				from_period: [results.default_fromperiod, [Validators.required]],
				to_period: [results.default_toperiod, [Validators.required]],
				gl_tag: [null],
			});
		});
		this.generalLedgerService.getTags().subscribe((r: any) => {
			this.tags = r.tags || [];
		});
	}

	updateToOptions(value: any): void {
		this.to_period_options = this.periods.filter((p: any) => parseInt(p.periodno, 10) >= parseInt(value, 10));
	}

	updateFromOptions(value: any): void {
		this.from_period_options = this.periods.filter((p: any) => parseInt(p.periodno, 10) <= parseInt(value, 10));
	}

	back(): void {
		this.location.back();
	}

	runReport(): void {
		if (!this.formGroup || !this.formGroup.valid) { return; }
		this.loading = true;
		const val = this.formGroup.value;
		const payload: any = {
			from_period: val.from_period,
			to_period: val.to_period,
		};
		if (val.gl_tag != null && val.gl_tag !== '') {
			const tagId = val.gl_tag && val.gl_tag.tagId !== undefined ? val.gl_tag.tagId : val.gl_tag;
			if (tagId !== '' && tagId != null) {
				payload.gl_tag = tagId;
			}
		}
		this.generalLedgerService.getExpenseByDepartment(payload).subscribe({
			next: (results: any) => {
				this.loading = false;
				if (results.error) {
					this.globalSearchService.showNotification(results.error, 'danger', 'bottom', 'center');
					return;
				}
				this.report = results;
				this.title = results.title || 'Expense by Department';
			},
			error: () => {
				this.loading = false;
			}
		});
	}

	exportExcel(): void {
		if (!this.report || !this.report.by_department) { return; }
		const rows: any[] = [];
		this.report.by_department.forEach((dept: any) => {
			rows.push({ Department: dept.tagdescription, Total: dept.total });
			(dept.accounts || []).forEach((acc: any) => {
				rows.push({
					Department: '',
					Account: acc.accountcode,
					AccountName: acc.accountname,
					Group: acc.groupname,
					Amount: acc.amount,
				});
			});
		});
		rows.push({ Department: 'Total', Total: this.report.total });
		this.globalSearchService.exportJsonToExcel(rows, 'ExpenseByDepartment_' + new Date().toISOString().slice(0, 10) + '.xlsx');
	}
}
